<template>
  <div
    class="file-display"
    :class="
      fileHeader && fileHeader === 'data:application/pdf;base64' && 'is-pdf'
    "
  >
    <object v-if="fileSource">
      <embed :src="fileSource" />
    </object>
    <v-btn
      icon
      class="cancel-button"
      @click="removeFile"
      v-if="showCancelButton"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>
    
<script>
export default {
  props: {
    fileSource: {
      type: String,
    },
    fileHeader: {
      type: String,
    },
    showCancelButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    removeFile() {
      this.$emit("removeFile");
    },
  },
};
</script>
    
<style lang="scss" scoped>
.file-display {
  position: relative;
  width: fit-content;
  height: fit-content;
  &.is-pdf {
    height: 100%;
    width: 100%;
    object {
      height: 100%;
      width: 100%;
      embed {
        height: 100%;
        width: 100%;
      }
    }
  }
  .cancel-button {
    position: absolute;
    top: -18px;
    right: -18px;
    border: 1px solid $qvo-color-red-300;
    background: white;
    .v-icon {
      color: $qvo-color-red-300;
    }
  }
  object {
    display: flex;
    border: 2px dashed $qvo-color-grey-400;
    border-radius: 8px;
    padding: $qvo-spacing-8;
    margin: 0 auto;
    width: fit-content;
    embed {
      max-width: 100%;
    }
  }
}
</style>